import { useEffect, useState } from 'react';

// @ts-ignore
import Worker from '../pdf.worker?worker';
import { PdfGeneratorData } from '../pdf-generator';

const worker = new Worker();

export const useRenderPDF = (props: PdfGeneratorData) => {
  const [url, setUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    worker.postMessage(props);

    worker.addEventListener(
      'message',
      (msg: MessageEvent<string | undefined>) => {
        if (!msg?.data) return setUrl(undefined);
        return setUrl(msg.data);
      }
    );
  }, []);

  useEffect(() => (url ? () => URL.revokeObjectURL(url) : undefined), [url]);

  return url;
};
